export default __webpack_public_path__ + "static/media/gold_tier.2164ba7e.svg";